import accountLogin from '@/components/account/account-login/account-login.vue';
import accountLoginFooter from '@/components/account/account-login/footer/footer.vue';

export default {
  components: {
    accountLogin,
    accountLoginFooter,
  },
};
